import React from "react";
import { ReactComponent as EditIcon } from "../../assets/icons/management/edit.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/management/info.svg";
import { IBlog } from "../../types/blogs.type";
import styles from "./styles.module.scss";

interface Props {
  blogs: IBlog[];
  callBackInfo: (bool: boolean) => void;
  callBackEdit: (blog: IBlog) => void;
}

const BlogsTable: React.FC<Props> = (props) => {
  return (
    <table className={styles.customTable}>
      <thead>
        <tr>
          <th>Title</th>
          <th>Slug</th>
          <th>Type</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {props.blogs?.map((blog) => (
          <tr key={blog.id}>
            <td>
              <div className={styles.userInfo}>
                {blog.coverImageUrl && (
                  <img
                    src={blog.coverImageUrl}
                    alt={blog.title}
                    className={styles.avatar}
                  />
                )}
                <div className={styles.nameContainer}>
                  <span className={styles.name}>{blog.title}</span>
                </div>
              </div>
            </td>
            <td className={styles.role}>{blog.slug}</td>
            <td className={styles.role}>{blog.type}</td>
            <td>
              <span
                className={`${styles.status} ${
                  blog.status === "published"
                    ? styles.registered
                    : styles.notRegistered
                }`}
              >
                {blog.status}
              </span>
            </td>
            <td>
              <div className={styles.actions}>
                <button
                  className={styles.editBtn}
                  onClick={() => {
                    props.callBackInfo(false);
                    props.callBackEdit(blog);
                  }}
                >
                  <EditIcon />
                </button>
                <button
                  className={styles.infoBtn}
                  onClick={() => {
                    props.callBackInfo(true);
                    props.callBackEdit(blog);
                  }}
                >
                  <InfoIcon />
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default BlogsTable;
